import React from "react"
import CoolPage from "./CoolPage"

/* Specialized version of page */

const FixedPage = (props) => (
  <CoolPage fixedBar {...props} />
)

export default FixedPage



// WEBPACK FOOTER //
// ./src/app/catalogo/components/FixedBarPage.jsx